<template>
  <fragment>
    <mc-app-header
      :title="`dailyChallenges of ${displayName(users.selected)}`"
    />
    <mc-app-body>
      <div class="daily-challenges section">
        <b-loading
          v-if="dailyChallenges.userDataLoading"
          :is-full-page="false"
          :active="true"
        ></b-loading>
        <calendar-view
          :events="events"
          :show-date="showDate"
          class="theme-default"
          display-period-uom="month"
          :disable-future="true"
        >
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="newDate => (showDate = newDate)"
          />
        </calendar-view>
      </div>
    </mc-app-body>
  </fragment>
</template>
<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar';
import { mapState, mapActions } from 'vuex';

require('vue-simple-calendar/static/css/default.css');
require('vue-simple-calendar/static/css/holidays-us.css');

import { displayName } from '../../../utils/user';
import { Timestamp } from '../../../firebase';

export default {
  data() {
    return {
      showDate: new Date()
    };
  },
  created() {
    this.load();
  },
  computed: {
    ...mapState(['dailyChallenges', 'users']),
    userId() {
      return this.$route.params.id;
    },
    events() {
      return this.dailyChallenges.userData.map(attempt => {
        return {
          id: `${attempt.date.seconds}`,
          startDate: attempt.date.toDate(),
          title: attempt.answer,
          classes: `tag ${attempt.correct ? 'is-success' : 'is-danger'}`
        };
      });
    }
  },
  methods: {
    ...mapActions('users', ['selectUser']),
    ...mapActions('dailyChallenges', ['loadUserData']),
    displayName,
    getMonthBoundary(date) {
      const fromDate = date.toDate();
      fromDate.setHours(0, 0, 0, 0);
      fromDate.setDate(1);
      const toDate = new Date(fromDate);
      toDate.setMonth(toDate.getMonth() + 1);
      return {
        fromDate: Timestamp.fromDate(fromDate),
        toDate: Timestamp.fromDate(toDate)
      };
    },
    load() {
      this.selectUser(this.userId);
      this.loadUserData({
        userId: this.userId,
        ...this.getMonthBoundary(Timestamp.fromDate(this.showDate))
      });
    }
  },
  components: {
    CalendarView,
    CalendarViewHeader
  }
};
</script>

<style lang="scss" scoped>
.daily-challenges {
  height: 100%;
  .loading-overlay {
    z-index: 1;
  }
}
</style>
